import { Build } from '@mui/icons-material';
import { Box, Card, CardActionArea, CardContent, Chip, LinearProgress, Typography } from '@mui/material';
import React from 'react';
import { formatCurrencyInCents } from '../../helpers/formatters';
import { getPrinterBrandBadgeProps } from '../../helpers/printerBrand';
import MaintenanceDowntimeText from '../printers/MaintenanceDowntimeText';
import PrinterFilamentSlots from '../printers/PrinterFilamentSlots';

export default function MaintenancePrinterSummaryCard({ printer, downtimePercent = 0, onSelect }) {
    const brandBadge = getPrinterBrandBadgeProps(printer.brand);
    const downtimeMinutes = Number(printer.downtime_minutes) || 0;
    const barValue = downtimeMinutes > 0 ? Math.min(100, downtimePercent) : 0;

    return (
        <Card variant="outlined" sx={{ height: '100%' }}>
            <CardActionArea
                onClick={() => onSelect?.(printer.printer_uuid)}
                sx={{ height: '100%' }}
                aria-label={`Filtrar manutenções de ${printer.name}`}
            >
                <CardContent>
                    <Box sx={{ mb: 1.5 }}>
                        {brandBadge ? (
                            <Chip label={printer.name} size="small" {...brandBadge} />
                        ) : (
                            <Typography variant="subtitle1" fontWeight={700} noWrap>
                                {printer.name}
                            </Typography>
                        )}
                    </Box>
                    <Box sx={{ mb: 1.5 }} onClick={(event) => event.stopPropagation()}>
                        <PrinterFilamentSlots
                            printerUuid={printer.printer_uuid || printer.id}
                            printerName={printer.name}
                            filaments={printer.filaments}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.5 }}>
                        <Build fontSize="small" color="action" />
                        <Typography variant="body2" color="text.secondary">
                            Interrupções
                        </Typography>
                    </Box>
                    <Typography variant="h5" fontWeight={800} sx={{ mb: 0.5 }}>
                        {downtimeMinutes > 0 ? (
                            <MaintenanceDowntimeText
                                totalMinutes={downtimeMinutes}
                                durationSx={{ fontWeight: 800 }}
                                suffixSx={{ fontWeight: 400, fontSize: '1rem' }}
                            />
                        ) : (
                            '—'
                        )}
                        <Typography component="span" variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                            ({printer.maintenance_count} manutenções)
                        </Typography>
                    </Typography>
                    {Number(printer.parts_total_cents) > 0 && (
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            Gasto em peças: {formatCurrencyInCents(printer.parts_total_cents)}
                        </Typography>
                    )}
                    <LinearProgress
                        variant="determinate"
                        value={barValue}
                        sx={{ height: 6, borderRadius: 1 }}
                    />
                </CardContent>
            </CardActionArea>
        </Card>
    );
}
